<script>
    import { classNames } from "../../utils";
    export let fallback = "https://via.placeholder.com/88/EEEEEE/333333?text=S";
    //'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
    export let fit = "cover";
    export let src = "";

    const cls = "sui-avatar";
</script>

<div
    class={classNames({
        [cls]: cls,
        [$$props.class]: $$props.class,
    })}
>
    {#if src}
        <img {src} style:object-fit={fit} alt="" />
    {:else}
        <img src={fallback} style:object-fit={fit} alt="" />
    {/if}
</div>

<style lang="less">
    @import "./avatar.less";
</style>
